import { derived } from 'svelte/store';

function deriveCalculators(... calculatorStores) {
    return derived(calculatorStores, ($calculatorStores) => {
        let counter = 0;
        $calculatorStores.forEach(($calculatorStore) => {
            let amount = $calculatorStore.amount;
            let unitsPerItem = $calculatorStore.unitsPerItem;
            let totalUnits = amount * unitsPerItem;
            if (amount && unitsPerItem) {
                counter += totalUnits * getUnitPrice($calculatorStore);
            }
        });
        return parseFloat(counter).toFixed(2);
    })
}

function getUnitPrice(calculatorStore) {
    let amount = calculatorStore.amount;
    let unitsPerItem = calculatorStore.unitsPerItem;
    let totalUnits = amount * unitsPerItem;
    return calculatorStore.priceStrategy(totalUnits);
}

export {
    deriveCalculators,
    getUnitPrice
}